// Main Application Component
import { Link } from 'react-router-dom';
import problem from './problem.webp';
import problem2 from './problem2.webp';
import solution from './solution.webp';
import Offerings from './Offerings';

// Home Page Component
function Home() {
  return (
    <>
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay">
          <div className="hero-content">
            <h1 className="hero-title">Stop Compromising. Start Growing.</h1>
            <p className="hero-subtitle">
              We bridge the gap between big ideas and tight budgets. 
              Trailblaze Digital provides the end-to-end creative, tech, 
              and SaaS solutions new entrepreneurs need to compete from day one—without 
              the agency price tag.
            </p>
            <div className="hero-buttons">
              <Link to="/contact" className="btn-primary magnetic-element">Start trailblazing</Link>
              <Link to="/about" className="btn-secondary magnetic-element">Learn about Us</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main>
        <div className="App-header">
          <img src={problem} className="Problem-icon magnetic-element" alt="Problem icon" />
          <h1>The "Survival Mode" Trap</h1>
          <p>
          You have the vision, but the digital marketplace is crowded and expensive. 
          We know the struggle: you can't afford big-name agencies, but relying on cheap, 
          low-quality content means your brand is ignored.
          This cycle traps incredible small businesses in survival mode. 
          Instead of building a strong foundation and scaling, 
          you’re stuck making tough compromises just to keep the lights on.
          </p>
        <div className="pain-points">
          <div className='pain-points-heading'>
          <h3>Pain Points</h3>
          <img src={problem2} className="Problem2-icon magnetic-element" alt="Problem Bulb icon" />
          </div>
          <div className='pain-points list'>
          <ul>
            <li><strong>Overpaying</strong> agencies that don't understand startup agility.</li>
            <li><strong>Limited Budget:</strong> High-quality agencies are out of reach financially.</li>
            <li><strong>Inconsistent Quality:</strong> Cheap solutions lead to subpar branding and user experience.</li>
          </ul>
          </div>
          </div>
        </div>

        <div className="App-header">
          <img src={solution} className="Solution-icon magnetic-element" alt="Solution icon" />
          <h1>
            Enter <strong>Trailblaze Digital:</strong> Your New Growth Partner.
          </h1>
          <h2>We empower new entrepreneurs to launch with confidence.</h2>
          <br></br>
          <p>
           We are a Full-Service Digital Creative and SaaS Studio designed 
           specifically for the modern startup. We don't just deliver files and walk away; 
           we equip your business with the foundational tools needed to attract customers 
           and scale effectively. We turn bold ideas into thriving digital ventures.
          </p>
        </div>
      </main>
      <Offerings />  
    </>
  );
}
export default Home;